import { getDateWithSpecificFormat } from '../../../../data-transform';


export default function myPaymentsTableColumns(config){
    //console.log(config);
    let result = {};
    let tableData = [];

    config.data.forEach(payment => {
        let row = [];
        const rowId = payment.dealId;
        config.columns.forEach(column => {
           // console.log(column);
            let columnValue = "";

            let displayAsIs = column.data.displayInBodyAsIs;
            if (column.data.displayInBodyAs === "string") {
                if (column.id === "collectionNumber") {
                    columnValue = payment.dealId || "";
                    displayAsIs = true;
                }
                if (column.id === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(payment.dealExpirationDate) || "";
                    displayAsIs = true;
                }
                if (column.id === "paymentStatus") {
                    columnValue = payment.status || "";
                    displayAsIs = true;
                }
                if (column.id === "paymentDate") {
                    columnValue = getDateWithSpecificFormat(payment.dealExpirationDate) || "";
                    displayAsIs = true;
                }
                if (column.id === "expectedPaymentDate") {
                    columnValue = getDateWithSpecificFormat(payment.dealExpirationDate) || "";
                    displayAsIs = true;
                }
                if (column.id === "amount") {
                    columnValue = payment.priceList || "";
                    displayAsIs = true;
                }
                if (column.id === "invoiceInstructions") {
                    columnValue = payment.email || "";
                    displayAsIs = true;
                }
                if (column.id === "paymentInstructions") {
                    columnValue = payment.email || "";
                    displayAsIs = true;
                }
            }
            row.push({
                [column.id] : {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs
                }
            });
        });
        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}